import { Button } from '@chakra-ui/react';
import { useModalDispatch } from '@olo-web/client-state';
import { EAuthEntryPoints, EModalTypes } from '@olo-web/types/enums';
import { useCustomer } from '@olo-web/domain/customer/queries/useCustomer';

export const SignInButton = ({ children }) => {
  const modalDispatch = useModalDispatch();
  const { data: customerData } = useCustomer();

  const handleSignInClick = () => {
    modalDispatch({
      type: 'OPEN_MODAL',
      payload: {
        modalKey: EModalTypes.LOGIN,
        analyticsAuthEntryPoint: EAuthEntryPoints.CHECKOUT_CONTACT_INFO,
      },
    });
  };

  return customerData ? null : (
    <Button
      variant="tertiary"
      colorScheme="primary"
      color="primary.350"
      textDecor="underline"
      p={0}
      fontWeight="normal"
      mt={-4}
      onClick={handleSignInClick}
      data-testid="sign-into-your-account-button"
    >
      {children}
    </Button>
  );
};
